import { client } from "utils";

export const getReceiversRequest = () => client.get("receiver");
